<div [class.card]="enCarte">
	<div [class.card-body]="enCarte">
		@if (enCarte) {
			<h5 class="card-title mb-3">Notifications</h5>
		}
		@switch (state) {
			@case ("unsupported") {
				<p class="text-muted mb-0">Les notifications ne sont pas disponibles sur ce navigateur.</p>
			}
			@case ("ios-install") {
				<p class="text-muted mb-0">
					Pour recevoir les notifications sur iPhone : touchez <strong>Partager</strong> puis <strong>Sur l'écran d'accueil</strong>, puis ouvrez
					l'application depuis l'icône.
				</p>
			}
			@case ("denied") {
				<p class="text-muted mb-0">Notifications bloquées. Autorisez-les dans les réglages du navigateur.</p>
			}
			@case ("enabled") {
				<p class="text-success mb-3"><i class="ri-notification-3-line align-bottom me-1"></i> Notifications activées sur cet appareil</p>
				<div class="d-flex flex-wrap gap-2">
					<gm-button-primary label="Envoyer un test" [estConsultation]="true" [loading]="isTesting" (clickBtn)="envoyerTest()"></gm-button-primary>
					<gm-button-primary label="Désactiver" color="wlight" btnCta="secondary" [estConsultation]="true" [loading]="isUnsubscribing" (clickBtn)="desactiver()"></gm-button-primary>
				</div>
			}
			@default {
				<p class="text-muted mb-3">Recevez une notification sur cet appareil, même lorsque l'application est fermée.</p>
				<gm-button-primary label="Activer les notifications" [estConsultation]="true" [loading]="isSubscribing" (clickBtn)="activer()"></gm-button-primary>
			}
		}
	</div>
</div>
